import React from 'react';
import { useNavigate } from 'react-router-dom';
import qrCodePoster from '../../../assets/creative/posters/Bronco_Sport-EN_V1_300x250.jpg';
import shoppablePoster from '../../../assets/creative/shoppable/display_16_9.jpg';
import './innovation-ads.css';

const InnovationAds = () => {
    const navigate = useNavigate();

    return (
        <div className="ia-page">
            <div className="ia-header-row">
                <div>
                    <div className="ia-title-row">
                        <h2 className="ia-title">Innovation Ads</h2>
                        <span className="ia-badge-new">NEW</span>
                    </div>
                    <p className="ia-subheading">
                        Enhance your creatives with research-backed, dynamic experiences that capture attention and drive better results.
                    </p>
                </div>
            </div>

            <div className="ia-section-header-row">
                <div>
                    <h3 className="ia-section-title">Popular Formats</h3>
                    <p className="ia-section-subtext">Choose a format below to preview how it enhances your existing ad creative.</p>
                </div>
            </div>

            <div className="ia-cards-grid">
                {/* ---------- QR Code ---------- */}
                <div className="ia-format-card">
                    <div className="ia-format-card-header">
                        <div>
                            <div className="ia-format-icon purple">
                                <i className="fa-solid fa-qrcode"></i>
                            </div>
                            <h4 className="ia-format-title">QR Code</h4>
                            <span className="ia-format-tag">CTV</span>
                        </div>
                        <button type="button" className="ia-format-menu-btn" aria-label="More options">
                            <i className="fa-solid fa-ellipsis-vertical"></i>
                        </button>
                    </div>

                    <img className="ia-format-preview-img" src={qrCodePoster} alt="QR Code enhancement example" />

                    <p className="ia-format-desc">Drive interaction directly from your CTV ads with a simple scan.</p>

                    <span className="ia-supported-on-label">Supported on:</span>
                    <div className="ia-supported-on-row">
                        <span className="ia-supported-chip"><i className="fa-solid fa-tv"></i> CTV</span>
                    </div>

                    <button
                        type="button"
                        className="ia-btn ia-btn-outline ia-configure-btn"
                        onClick={() => navigate('/innovation-ads/qr-code')}
                    >
                        Preview &amp; Configure
                    </button>
                </div>

                {/* ---------- Shoppable Ads ---------- */}
                <div className="ia-format-card">
                    <div className="ia-format-card-header">
                        <div>
                            <div className="ia-format-icon green">
                                <i className="fa-solid fa-bag-shopping"></i>
                            </div>
                            <h4 className="ia-format-title">Shoppable Ads</h4>
                            <span className="ia-format-tag">OLV / Display</span>
                        </div>
                        <button type="button" className="ia-format-menu-btn" aria-label="More options">
                            <i className="fa-solid fa-ellipsis-vertical"></i>
                        </button>
                    </div>

                    <img className="ia-format-preview-img" src={shoppablePoster} alt="Shoppable Ads enhancement example" />

                    <p className="ia-format-desc">Interactive product panels that help viewers discover and shop featured products.</p>

                    <span className="ia-supported-on-label">Supported on:</span>
                    <div className="ia-supported-on-row">
                        <span className="ia-supported-chip"><i className="fa-solid fa-rectangle-ad"></i> OLV</span>
                        <span className="ia-supported-chip"><i className="fa-solid fa-display"></i> Display</span>
                    </div>

                    <div className="ia-configure-btn-row">
                        <button
                            type="button"
                            className="ia-btn ia-btn-outline ia-configure-btn"
                            onClick={() => navigate('/innovation-ads/shoppable', { state: { format: 'olv' } })}
                        >
                            Preview &amp; Configure OLV
                        </button>
                        <button
                            type="button"
                            className="ia-btn ia-btn-outline ia-configure-btn"
                            onClick={() => navigate('/innovation-ads/shoppable', { state: { format: 'display' } })}
                        >
                            Preview &amp; Configure Display
                        </button>
                    </div>
                </div>
            </div>

            <div className="ia-value-strip">
                <div className="ia-value-item">
                    <i className="fa-solid fa-globe ia-value-icon"></i>
                    <div>
                        <p className="ia-value-title">Research Backed</p>
                        <p className="ia-value-desc">Every enhancement is grounded in behavioral and cognitive research.</p>
                    </div>
                </div>
                <div className="ia-value-item">
                    <i className="fa-solid fa-circle-check ia-value-icon"></i>
                    <div>
                        <p className="ia-value-title">Hands-Free Activation</p>
                        <p className="ia-value-desc">No assets to share. No trafficking. Everything handled in the backend.</p>
                    </div>
                </div>
                <div className="ia-value-item">
                    <i className="fa-solid fa-arrow-trend-up ia-value-icon"></i>
                    <div>
                        <p className="ia-value-title">Proven Impact</p>
                        <p className="ia-value-desc">Enhancements shown to increase attention, comprehension &amp; results.</p>
                    </div>
                </div>
                <div className="ia-value-item">
                    <i className="fa-solid fa-shield ia-value-icon"></i>
                    <div>
                        <p className="ia-value-title">Safe &amp; Brand Friendly</p>
                        <p className="ia-value-desc">All formats are brand safe and publisher approved.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InnovationAds;
